"use strict";

exports.__esModule = true;

var Methods_1 = require("../definitions/Methods");

var parse_1 = require("./parse");

var Transform_1 = require("../Transform"); // import Construct from './construct'

/**
 * Hook a console constructor and forward messages to a callback
 * @argument console The Console constructor to Hook
 * @argument callback The callback to be called once a message is logged
 */


function Hook(console, callback, encode) {
  if (encode === void 0) {
    encode = true;
  }

  var TargetConsole = console;
  var Storage = {
    pointers: {},
    src: {
      npm: 'https://npmjs.com/package/console-feed',
      github: 'https://github.com/samdenty99/console-feed'
    }
  };

  var _loop_1 = function _loop_1(method) {
    var NativeMethod = TargetConsole[method]; // Override

    TargetConsole[method] = function () {
      // Pass back to native method
      NativeMethod.apply(this, arguments); // Parse arguments and send to transport

      var args = [].slice.call(arguments); // setTimeout to prevent lag

      setTimeout(function () {
        var parsed = parse_1["default"](method, args);

        if (parsed) {
          var encoded = parsed;

          if (encode) {
            encoded = Transform_1.Encode(parsed);
          }

          callback(encoded, parsed);
        }
      });
    }; // Store native methods


    Storage.pointers[method] = NativeMethod;
  }; // Override console methods


  for (var _i = 0, Methods_2 = Methods_1["default"]; _i < Methods_2.length; _i++) {
    var method = Methods_2[_i];

    _loop_1(method);
  }

  TargetConsole.feed = Storage;
  return TargetConsole;
}

exports["default"] = Hook;